/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { slackDirectoryConnectionsList } from "../funcs/slackDirectoryConnectionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListResponseBody } from "../models/components/listresponsebody.js";
import {
  ListSlackDirectoryConnectionsRequest,
  ListSlackDirectoryConnectionsSecurity,
} from "../models/operations/listslackdirectoryconnections.js";
import { unwrapAsync } from "../types/fp.js";
export type SlackDirectoryConnectionsQueryData = ListResponseBody;

export function prefetchSlackDirectoryConnections(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSlackDirectoryConnectionsRequest | undefined,
  security?: ListSlackDirectoryConnectionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSlackDirectoryConnectionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSlackDirectoryConnectionsQuery(
  client$: GramCore,
  request?: ListSlackDirectoryConnectionsRequest | undefined,
  security?: ListSlackDirectoryConnectionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SlackDirectoryConnectionsQueryData>;
} {
  return {
    queryKey: queryKeySlackDirectoryConnections({
      gramSession: request?.gramSession,
    }),
    queryFn: async function slackDirectoryConnectionsQueryFn(
      ctx,
    ): Promise<SlackDirectoryConnectionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(slackDirectoryConnectionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySlackDirectoryConnections(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "slackDirectoryConnections", "list", parameters];
}
